module.exports = __webpack_public_path__ + "img/42.f07d3ba6.png";